/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
// TODO: move everything here to the base-label-aware-component file
/**
 * Determines if an object is label aware.
 * @param obj - The object to check.
 * @returns True if the object is label aware, false otherwise.
 */
export const isLabelAware = (obj) => {
    return typeof obj.labelChangedCallback === 'function';
};
